import * as React from 'react'
import autobind from 'autobind-decorator'
import { connect } from 'redux-scaffolding-ts'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Icon } from 'antd'
import { DropDownEmployeesStore, EmployeeSummary } from 'src/stores/employees-store'
import { ItemReference, QueryResult } from 'src/core/stores/dataStore'
import SelectionInput from '../core/ui/form/selectionInput'

interface EmployeeEditorProps extends WithTranslation {
  companyId: string,
  disabled?: boolean,
  value?: number,
  onChange?: (value: any) => void,
  placeholder?: string,
  nullable?: boolean,
  minWidth?: number,
  multiple?: boolean,
  excludeProjectMembers?: string
  onLoadAll?: (employees: EmployeeSummary[]) => void
  loadOnCreation?: boolean
}

interface EmployeeEditorState {
  employeeId: number | undefined,
}

@connect(["dropdownemployees", DropDownEmployeesStore])
class EmployeeEditor extends React.Component<EmployeeEditorProps, EmployeeEditorState> {

  private get employeesStore() {
    return (this.props as any).dropdownemployees as DropDownEmployeesStore
  }

  constructor(props: EmployeeEditorProps) {
    super(props)
    this.state = {
      employeeId: props.value
    }
    this.employeesStore.changeUrl(props.companyId)
    if (props.loadOnCreation) {
      this.getAll()
    }
  }

  static getDerivedStateFromProps(nextProps: EmployeeEditorProps, prevState: EmployeeEditorState) {
    if (nextProps.value !== prevState.employeeId) {
      return { employeeId: nextProps.value }
    }
    else return null
  }

  private async getAll() {
    var result = await this.employeesStore.getAllAsync({
      searchQuery: "",
      skip: 0,
      parameters: {
        "includeIds": this.props.value,
        "excludeProjectMembers": this.props.excludeProjectMembers
      },

      take: 1000,
      orderBy: [{ field: 'title', direction: "Ascending", useProfile: true }]
    }) || { count: 0, items: [] }

    if (this.props.onLoadAll)
      this.props.onLoadAll(result.items)

  }

  @autobind
  private async getEmployees(searchQuery: string): Promise<QueryResult<ItemReference>> {
    var result = await this.employeesStore.getAllAsync({
      searchQuery: searchQuery,
      skip: 0,
      parameters: {
        "includeIds": this.props.value,
        "excludeProjectMembers": this.props.excludeProjectMembers
      },

      take: 20,
      orderBy: [{ field: 'title', direction: "Ascending", useProfile: true }]
    }) || { count: 0, items: [] }

    return {
      count: result.count,
      items: result.items.map(o => ({
        id: `${o.id}`,
        title: `${o.title}`
      } as ItemReference))
    } as QueryResult<ItemReference>
  }

  public render() {
    return (<SelectionInput
      content={(o) =>
        <div>
          <Icon type="idcard" />
          <span>&nbsp;{o ? o.title : ""}</span>
        </div>}
      disabled={this.props.disabled}
      minWidth={this.props.minWidth}
      nullable={this.props.nullable}
      placeholder={this.props.placeholder}
      query={this.getEmployees}
      value={this.state.employeeId as any}
      multiple={this.props.multiple}
      showFooter
      onChange={(item: any) => { if (this.props.onChange) { this.props.onChange(item && item.id ? item.id : item as any || undefined) } }} />)
  }
}

export default withTranslation()(EmployeeEditor)